import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=6768b158&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=ts&"
export * from "./Result.vue?vue&type=script&lang=ts&"
import style0 from "./Result.vue?vue&type=style&index=0&id=6768b158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768b158",
  null
  
)

export default component.exports